import { useState } from 'react'
import toast from 'react-hot-toast'
import {Mail} from 'lucide-react'
import { useLanguage } from '@/context/LanguageContext'

function NewsletterForm() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const { t } = useLanguage()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!email.includes('@')) {
      toast.error('Informe um e-mail válido.')
      return
    }
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
      setEmail('')
      toast.success('Inscrição realizada com sucesso!')
    }, 700)
  }

  return (
    <form onSubmit={handleSubmit} className="flex w-full max-w-md flex-col gap-2 sm:flex-row">
      <label htmlFor="newsletter-email" className="sr-only">{t('newsletter.placeholder')}</label>
      <div className="relative flex-1">
        <Mail className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" aria-hidden="true" />
        <input
          id="newsletter-email"
          type="email"
          required
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder={t('newsletter.placeholder')}
          className="w-full rounded-lg border border-slate-700 bg-slate-800 py-2.5 pl-10 pr-3 text-sm text-white placeholder:text-slate-500 focus:border-cyan-500 focus:outline-none focus:ring-1 focus:ring-cyan-500"
        />
      </div>
      <button
        type="submit"
        disabled={loading}
        className="shrink-0 rounded-lg bg-cyan-600 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-cyan-700 disabled:opacity-60"
      >
        {loading ? '...' : t('newsletter.button')}
      </button>
    </form>
  )
}

export default NewsletterForm
